import type { OwnAttentionItem } from '../api/contracts'
import { momentText } from './time'

/** Названия видов ведомости (CASH-CONTRACTS §6 и сторожа RP-OWN9). Неизвестный вид показывается своим кодом, а не прячется. */
const KIND_LABELS: Readonly<Record<string, string>> = {
  'card-money-without-receipt': 'Деньги по карте без чека',
  'in-doubt': 'Неизвестный исход операции',
  'possible-double-receipt': 'Возможный двойной чек',
  'cashier-unbound': 'Кассир записи не привязан',
  'rejected-revision': 'Запись отклонена сервером',
  'operation-conflict': 'Конфликт записи',
  'agent-silent': 'Кассовый агент молчит',
  'silent-operation': 'Операция без новостей',
  'shift-total-mismatch': 'Итог смены расходится с журналом',
}

export interface AttentionRowVm {
  id: number
  kindLabel: string
  stateText: string
  open: boolean
  text: string
  meta: readonly string[]
  /** Готовый текст для передачи администратору. */
  report: string
}

export function attentionKindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? kind
}

/** Открытые выше закрытых, внутри — свежие выше. */
export function attentionRowsOf(items: readonly OwnAttentionItem[]): readonly AttentionRowVm[] {
  const sorted = [...items].sort((a, b) => Number(b.open) - Number(a.open) || Date.parse(b.createdAt) - Date.parse(a.createdAt))
  return sorted.map((item) => {
    const kindLabel = attentionKindLabel(item.kind)
    const meta = [
      `Возникло ${momentText(item.createdAt)}`,
      ...(item.operationId === null ? [] : [`Операция ${item.operationId}${item.revision === null ? '' : `, ревизия ${item.revision}`}`]),
      `Агент ${item.agentId}`,
      `Код ${item.code}`,
      ...(item.closedAt === null ? [] : [`Закрыто ${momentText(item.closedAt)}${item.closedBy === null ? '' : `: ${item.closedBy}`}`]),
    ]
    return {
      id: item.id,
      kindLabel,
      stateText: item.open ? 'Открыто' : 'Закрыто',
      open: item.open,
      text: item.text,
      meta,
      report: [`Ведомость доставки: ${kindLabel} (${item.open ? 'открыто' : 'закрыто'})`, item.text, ...meta].join('\n'),
    }
  })
}
